module.exports = __webpack_public_path__ + "static/img/day3.7d7e7db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/day3.jpg
// module id = prZl
// module chunks = 0